import React from 'react'
import './button.css'

const BigButton = ({ name, className, type, disabled }) => {
  return (
    <button className={className} type={type} disabled={disabled}>
      {name}
    </button>
  )
}

export default BigButton
